/**
 * Esri reference raster overlays for satellite base (roads + place/admin labels).
 * Matches Esri "Imagery with Labels" composition: Transportation under Boundaries & Places.
 */

const REF_RASTER_LAYER = (id, sourceId) => ({
  id,
  type: 'raster',
  source: sourceId,
  minzoom: 0,
  maxzoom: 24,
  paint: { 'raster-fade-duration': 0 }
});

const REF_RASTER_SOURCE = (tiles) => ({
  type: 'raster',
  tiles,
  tileSize: 256,
  maxzoom: 18,
  attribution: '© Esri'
});

export const ESRI_REF_LAYER_IDS = {
  transportation: 'esri-reference-transportation',
  boundariesPlaces: 'esri-reference-boundaries-places'
};

export const ESRI_REF_SOURCE_IDS = {
  transportation: 'esri-ref-transportation',
  boundariesPlaces: 'esri-ref-boundaries-places'
};

/**
 * Add or remove Esri reference overlays on a Mapbox GL map.
 * @param {import('mapbox-gl').Map} map
 * @param {boolean} on
 * @param {{ transportationUrl: string, boundariesPlacesUrl: string }} urls
 */
export function applyEsriReferenceOverlays(map, on, { transportationUrl, boundariesPlacesUrl }) {
  if (!map) return;

  if (on) {
    try {
      if (!map.getSource(ESRI_REF_SOURCE_IDS.transportation)) {
        map.addSource(ESRI_REF_SOURCE_IDS.transportation, REF_RASTER_SOURCE([transportationUrl]));
      }
      if (!map.getLayer(ESRI_REF_LAYER_IDS.transportation)) {
        map.addLayer(REF_RASTER_LAYER(ESRI_REF_LAYER_IDS.transportation, ESRI_REF_SOURCE_IDS.transportation), undefined);
      }
      if (!map.getSource(ESRI_REF_SOURCE_IDS.boundariesPlaces)) {
        map.addSource(ESRI_REF_SOURCE_IDS.boundariesPlaces, REF_RASTER_SOURCE([boundariesPlacesUrl]));
      }
      if (!map.getLayer(ESRI_REF_LAYER_IDS.boundariesPlaces)) {
        map.addLayer(REF_RASTER_LAYER(ESRI_REF_LAYER_IDS.boundariesPlaces, ESRI_REF_SOURCE_IDS.boundariesPlaces), undefined);
      }
    } catch (_) {}
  } else {
    try {
      if (map.getLayer(ESRI_REF_LAYER_IDS.boundariesPlaces)) {
        map.removeLayer(ESRI_REF_LAYER_IDS.boundariesPlaces);
      }
      if (map.getSource(ESRI_REF_SOURCE_IDS.boundariesPlaces)) {
        map.removeSource(ESRI_REF_SOURCE_IDS.boundariesPlaces);
      }
      if (map.getLayer(ESRI_REF_LAYER_IDS.transportation)) {
        map.removeLayer(ESRI_REF_LAYER_IDS.transportation);
      }
      if (map.getSource(ESRI_REF_SOURCE_IDS.transportation)) {
        map.removeSource(ESRI_REF_SOURCE_IDS.transportation);
      }
    } catch (_) {}
  }
}
